import { styled } from '../../../../modules';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
    overflow: hidden;
`;

export const ScrollContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
    overflow-y: auto;
`;

export const Header = styled.header`
    width: 100%;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 24px;
    min-height: 80px;
`;

export const LogoImage = styled.img`
    max-height: 48px;
    max-width: 180px;
    object-fit: contain;
`;

export const HeroSection = styled.div`
    width: 100%;
    padding: 8px 24px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`;

export const Title = styled.h1<{ $color: string }>`
    font-size: 24px;
    font-weight: 400;
    color: ${({ $color }) => $color ?? '#0e3573'};
    margin: 0;
    line-height: 1.3;
    text-align: center;

    strong {
        font-weight: 800;
    }
`;

export const Description = styled.p<{ $color: string }>`
    font-size: 14px;
    font-weight: 400;
    color: ${({ $color }) => $color ?? '#718096'}cc;
    margin: 0;
    text-align: center;
    line-height: 1.5;
`;

export const FormSection = styled.div`
    width: 100%;
    padding: 0 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const ReadOnlyField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const FieldLabel = styled.label<{ $accentColor: string }>`
    font-size: 12px;
    font-weight: 700;
    color: ${({ $accentColor }) => $accentColor};
`;

export const FieldInput = styled.input`
    width: 100%;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #f9f9f9;
    font-size: 14px;
    color: #525866;
    outline: none;
    cursor: default;
    font-family: inherit;
`;

export const SelectGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const SelectLabel = styled.label<{ $accentColor: string }>`
    font-size: 12px;
    font-weight: 700;
    color: ${({ $accentColor }) => $accentColor};
`;

export const StyledSelect = styled.select`
    width: 100%;
    background-color: #19247e05;
    border: 1px solid rgb(204, 204, 204);
    height: 40px;
    border-radius: 4px;
    padding-left: 6.4px;
    padding-right: 32px;
    font-size: 14px;
    font-family: inherit;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 16px;
    cursor: pointer;

    option {
        padding: 12px;
        font-size: 14px;
        background-color: #f8f8f8;
        color: #333;
    }

    option:checked {
        background-color: #e6e6e6;
        font-weight: 500;
    }
`;

export const FooterSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 12px;
    padding: 16px 20px;
    background-color: #ffffff;
    border-top: 1px solid #e2e8f0;
    flex-shrink: 0;
`;

export const ButtonRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 12px;
`;
